import { render, staticRenderFns } from "./LifeStageIntro.vue?vue&type=template&id=408d4924&"
import script from "./LifeStageIntro.vue?vue&type=script&lang=js&"
export * from "./LifeStageIntro.vue?vue&type=script&lang=js&"
import style0 from "./LifeStageIntro.vue?vue&type=style&index=0&id=408d4924&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports